document.addEventListener('DOMContentLoaded', () => {
    function get_cookie(name) {
        let cookie = {};
        document.cookie.split(';').forEach(function(el) {
            let [key,value] = el.split('=');
            cookie[key.trim()] = value;
        });
        return cookie[name];
    }

    function dynamic_content_by_user_location(user_location) {
        if (user_location.country == 'US') {
            document.querySelector('.free-shipping-bar-section').style.display = 'block';
            document.querySelector('free-shipping').style.display = 'block';
        }
    }

    if (document.querySelector('.free-shipping-bar-section') || document.querySelector('free-shipping')) {
        if (get_cookie("api_location_region")) {
            let user_location = {
                region: get_cookie("api_location_region"),
                country: get_cookie("api_location_country")
            }
            dynamic_content_by_user_location(user_location);
            console.log(user_location);
            } else {
            async function getRegion() {
                let user_location;
                try {
                const response = await fetch('https://ipinfo.io/json');
                user_location = await response.json();
                } catch (error) {
                    if (error instanceof SyntaxError) {
                        console.log('There was a SyntaxError', error);
                    } else {
                        console.log('There was an error', error);
                    }
                }
                if (user_location) {
                    let end_date = new Date(Date.now() + 2628e6);
                    end_date = end_date.toUTCString();
                    document.cookie = "api_location_region="+user_location.region+"; expires="+end_date;
                    document.cookie = "api_location_country="+user_location.country+"; expires="+end_date;
                    dynamic_content_by_user_location(user_location);
                    console.log(user_location);
                }
            }
            getRegion();
        }
    }
})

function updateFreeShippingBar(totalPrice) {
    const bar = document.querySelector('.free-shipping-bar');
    if (!bar) return;

    const freeShipping = Number(bar.dataset.freeShipping);

    const before = bar.querySelector('.header-free-shipping-before');
    const after = bar.querySelector('.header-free-shipping-after');
    const price = bar.querySelector('.header-free-shipping-price');
    const container = bar.querySelector('.header-free-shipping-price-container');

    if (totalPrice >= freeShipping) {
        before.innerHTML = `You've qualified for free shipping! <a href="/cart" class="red-text">Checkout!</a>`;
        after.textContent = '';
        container.style.display = 'none';
        return;
    }

    before.textContent = totalPrice === 0 ? 'Spend' : 'You are only';
    price.textContent = ((freeShipping - totalPrice) / 100).toFixed(2);
    after.textContent = totalPrice === 0
        ? 'or more to get FREE shipping!'
        : 'away from FREE shipping!';

    container.style.display = '';
}

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('cart:item-added', async () => {
        const cart = await fetch('/cart.js').then(r => r.json());
        updateFreeShippingBar(cart.total_price);
    });
    document.addEventListener('line-item:change:end', (evt) => {
        updateFreeShippingBar(evt.detail.cart.total_price);
    });
})